// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__components__GroupHeader__root","image":"CentricUI__components__GroupHeader__image","placeholder":"CentricUI__components__GroupHeader__placeholder","textContainer":"CentricUI__components__GroupHeader__textContainer","title":"CentricUI__components__GroupHeader__title","subtitle":"CentricUI__components__GroupHeader__subtitle"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ui/components/GroupHeader.css
// module id = 594
// module chunks = 10